import { fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';

// FILTER ACTIONS
import {
  FETCH_PUBLISHERS_LIST, FETCHED_PUBLISHERS_LIST,
  FETCH_CATEGORIES_LIST, FETCHED_CATEGORIES_LIST,
  FETCH_KEYWORDS_LIST, FETCHED_KEYWORDS_LIST,
  FETCH_BRANDS_LIST, FETCHED_BRANDS_LIST,
 } from 'components/Global/Filters/actions.js';

 // APIs
import keywords from 'api/keywords.js';
import categories from 'api/categories.js';
import content from 'api/content.js';
import brands from 'api/brands.js';
import publishers from 'api/publishers.js';

// Actions
export const FETCH_COMPETITORS_FEED = 'FETCH_COMPETITORS_FEED';
export const FETCHED_COMPETITORS_FEED = 'FETCHED_COMPETITORS_FEED';
export const SET_COMPETITORS_FEED_FILTER = 'SET_COMPETITORS_FEED_FILTER';

export const FETCH_SUBSCRIBED_FEED = 'FETCH_SUBSCRIBED_FEED';
export const FETCHED_SUBSCRIBED_FEED = 'FETCHED_SUBSCRIBED_FEED';
export const SET_SUBSCRIBED_FEED_FILTER = 'SET_SUBSCRIBED_FEED_FILTER';

export const FETCH_SAVED_FEED = 'FETCH_SAVED_FEED';
export const FETCHED_SAVED_FEED = 'FETCHED_SAVED_FEED';
export const SET_SAVED_FEED_FILTER = 'SET_SAVED_FEED_FILTER';


// competitors
export const fetchCompetitorsKeywords = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().KeywordsList.keywordsList,
  fetchingActionType: FETCH_KEYWORDS_LIST,
  fetchedActionType: FETCHED_KEYWORDS_LIST,
  apiCall: (filters) => keywords.getCompetitorsKeywords(filters),
});

export const fetchCompetitorsCategories = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().CategoriesList.categoriesList,
  fetchingActionType: FETCH_CATEGORIES_LIST,
  fetchedActionType: FETCHED_CATEGORIES_LIST,
  apiCall: (filters) => categories.getCompetitorsCategories(filters),
});

export const fetchCompetitorsBrands = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().BrandsList.brandsList,
  fetchingActionType: FETCH_BRANDS_LIST,
  fetchedActionType: FETCHED_BRANDS_LIST,
  apiCall: (filters) => brands.getCompetitorsBrands(filters),
});

export const fetchCompetitorsPublishers = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().PublishersList.publishersList,
  fetchingActionType: FETCH_PUBLISHERS_LIST,
  fetchedActionType: FETCHED_PUBLISHERS_LIST,
  apiCall: (filters) => publishers.getCompetitorsPublishers(filters),
});

export const fetchCompetitorsFeed = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().Library.competitorContentList,
  fetchingActionType: FETCH_COMPETITORS_FEED,
  fetchedActionType: FETCHED_COMPETITORS_FEED,
  apiCall: filters => content.getCompetitorsContent(filters),
});


// Subscribed

export const fetchSubscribedKeywords = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().KeywordsList.keywordsList,
  fetchingActionType: FETCH_KEYWORDS_LIST,
  fetchedActionType: FETCHED_KEYWORDS_LIST,
  apiCall: (filters) => keywords.getSubscribedKeywords(filters),
});

export const fetchSubscribedCategories = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().CategoriesList.categoriesList,
  fetchingActionType: FETCH_CATEGORIES_LIST,
  fetchedActionType: FETCHED_CATEGORIES_LIST,
  apiCall: (filters) => categories.getSubscribedCategories(filters),
});

export const fetchSubscribedBrands = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().BrandsList.brandsList,
  fetchingActionType: FETCH_BRANDS_LIST,
  fetchedActionType: FETCHED_BRANDS_LIST,
  apiCall: (filters) => brands.getSubscribedBrands(filters),
});

export const fetchSubscribedPublishers = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().PublishersList.publishersList,
  fetchingActionType: FETCH_PUBLISHERS_LIST,
  fetchedActionType: FETCHED_PUBLISHERS_LIST,
  apiCall: (filters) => publishers.getSubscribedPublishers(filters),
});

export const fetchSubscribedFeed = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().Library.subscribedContentList,
  fetchingActionType: FETCH_SUBSCRIBED_FEED,
  fetchedActionType: FETCHED_SUBSCRIBED_FEED,
  apiCall: filters => content.getSubscribedContent(filters),
});

// Bookmarked

export const fetchSavedKeywords = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().KeywordsList.keywordsList,
  fetchingActionType: FETCH_KEYWORDS_LIST,
  fetchedActionType: FETCHED_KEYWORDS_LIST,
  apiCall: (filters) => keywords.getBookmarkedKeywords(filters),
});

export const fetchSavedCategories = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().CategoriesList.categoriesList,
  fetchingActionType: FETCH_CATEGORIES_LIST,
  fetchedActionType: FETCHED_CATEGORIES_LIST,
  apiCall: (filters) => categories.getBookmarkedCategories(filters),
});

export const fetchSavedBrands = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().BrandsList.brandsList,
  fetchingActionType: FETCH_BRANDS_LIST,
  fetchedActionType: FETCHED_BRANDS_LIST,
  apiCall: (filters) => brands.getBookmarkedBrands(filters),
});

export const fetchSavedPublishers = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().PublishersList.publishersList,
  fetchingActionType: FETCH_PUBLISHERS_LIST,
  fetchedActionType: FETCHED_PUBLISHERS_LIST,
  apiCall: (filters) => publishers.getBookmarkedPublishers(filters),
});

export const fetchSavedFeed = clear => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().Library.savedContentList,
  fetchingActionType: FETCH_SAVED_FEED,
  fetchedActionType: FETCHED_SAVED_FEED,
  apiCall: filters => content.getBookmarkedContent(filters),
});

export const preFetchLibraryPage = () => (dispatch) => Promise.all([
  dispatch(fetchCompetitorsKeywords(true)),
  dispatch(fetchCompetitorsCategories(true)),
  dispatch(fetchCompetitorsBrands(true)),
  dispatch(fetchCompetitorsPublishers(true)),
  dispatch(fetchCompetitorsFeed(true)),
]).then(() => setTimeout(() => Promise.all([
  dispatch(fetchSubscribedKeywords(true)),
  dispatch(fetchSubscribedCategories(true)),
  dispatch(fetchSubscribedBrands(true)),
  dispatch(fetchSubscribedPublishers(true)),
  dispatch(fetchSubscribedFeed(true)),
]).then(() => setTimeout(() => Promise.all([
  dispatch(fetchSavedKeywords(true)),
  dispatch(fetchSavedCategories(true)),
  dispatch(fetchSavedBrands(true)),
  dispatch(fetchSavedPublishers(true)),
  dispatch(fetchSavedFeed(true)),
]), 2000)), 2000));
